import { render, staticRenderFns } from "./Sendings.vue?vue&type=template&id=26260ed0"
import script from "./Sendings.vue?vue&type=script&lang=js"
export * from "./Sendings.vue?vue&type=script&lang=js"
import style0 from "./Sendings.vue?vue&type=style&index=0&id=26260ed0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports